module.exports = __webpack_public_path__ + "assets/d5aa6e33c0a492bda811b7a8ddef2e4f.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/anticipate/Anticipation.mp3
 ** module id = 204
 ** module chunks = 0
 **/